import { createContext, useContext, useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendPasswordResetEmail,
} from "firebase/auth";
import { auth, db } from "../config/fbConfig";
import { doc, setDoc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";

const userAuthContext = createContext();

export function UserAuthContextProvider({ children }) {
  const [user, setUser] = useState({});
  const [userData, setUserData] = useState(null);

  function logIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  async function signUp(email, password, firstName, lastName, phoneNumber, address, balance, oldBalance, addBalance, subtractBalance, pin) {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Add user data to Firestore
    await setDoc(doc(db, "users", user.uid), {
      firstName,
      lastName,
      phoneNumber,
      address,
      balance,
      oldBalance,
      addBalance,
      subtractBalance,
      pin,
      email: user.email,
      createdAt: serverTimestamp(),
    });

    return user;
  }

  function logOut() {
    return signOut(auth);
  }

  async function fetchUserData(userId) {
    const userDoc = await getDoc(doc(db, "users", userId));
    if (userDoc.exists()) {
      const data = userDoc.data();
      setUserData(data);
    }
  }

  function resetPassword(email) {
    return sendPasswordResetEmail(auth, email);
  }

  const verifyPin = async (currentPin) => {
    if (!user) return false;
    const userDoc = await getDoc(doc(db, "users", user.uid));
    if (!userDoc.exists()) return false;
    const userData = userDoc.data();
    return userData.pin === currentPin;
  };

  const updatePin = async (newPin) => {
    if (!user) throw new Error("No user is logged in");
    const userRef = doc(db, "users", user.uid);
    await updateDoc(userRef, { pin: newPin });
  };

  const updateBalance = async (newBalance) => {
    if (!user) throw new Error("No user is logged in");
    const userRef = doc(db, "users", user.uid);
    await updateDoc(userRef, { balance: newBalance });
    setUserData((prevData) => ({ ...prevData, balance: newBalance }));
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        await fetchUserData(currentUser.uid);
      } else {
        setUserData(null);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <userAuthContext.Provider
      value={{
        user,
        userData,
        logIn,
        signUp,
        logOut,
        resetPassword,
        verifyPin,
        updatePin,
        updateBalance
      }}
    >
      {children}
    </userAuthContext.Provider>
  );
}

export function useUserAuth() {
  return useContext(userAuthContext);
}







// import { createContext, useContext, useEffect, useState } from "react";
// import {
//   createUserWithEmailAndPassword,
//   signInWithEmailAndPassword,
//   onAuthStateChanged,
//   signOut,
//   sendPasswordResetEmail,
// } from "firebase/auth";
// import { auth, db } from "../config/fbConfig";
// import { doc, setDoc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";

// const userAuthContext = createContext();

// export function UserAuthContextProvider({ children }) {
//   const [user, setUser] = useState(null);
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true); // Add loading state

//   function logIn(email, password) {
//     return signInWithEmailAndPassword(auth, email, password);
//   }

//   async function signUp(email, password, firstName, lastName, phoneNumber, address, balance, oldBalance, addBalance, subtractBalance, pin) {
//     const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//     const user = userCredential.user;

//     // Add user data to Firestore
//     await setDoc(doc(db, "users", user.uid), {
//       firstName,
//       lastName,
//       phoneNumber,
//       address,
//       balance,
//       oldBalance,
//       addBalance,
//       subtractBalance,
//       pin,
//       email: user.email,
//       createdAt: serverTimestamp(),
//     });

//     return user;
//   }

//   function logOut() {
//     return signOut(auth);
//   }

//   async function fetchUserData(userId) {
//     const userDoc = await getDoc(doc(db, "users", userId));
//     if (userDoc.exists()) {
//       const data = userDoc.data();
//       setUserData(data);
//     }
//   }

//   function resetPassword(email) {
//     return sendPasswordResetEmail(auth, email);
//   }

//   const verifyPin = async (currentPin) => {
//     if (!user) return false;
//     const userDoc = await getDoc(doc(db, "users", user.uid));
//     if (!userDoc.exists()) return false;
//     const userData = userDoc.data();
//     return userData.pin === currentPin;
//   };

//   const updatePin = async (newPin) => {
//     if (!user) throw new Error("No user is logged in");
//     const userRef = doc(db, "users", user.uid);
//     await updateDoc(userRef, { pin: newPin });
//   };

//   const updateBalance = async (newBalance) => {
//     if (!user) throw new Error("No user is logged in");
//     const userRef = doc(db, "users", user.uid);
//     await updateDoc(userRef, { balance: newBalance });
//     setUserData((prevData) => ({ ...prevData, balance: newBalance }));
//   };

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
//       setLoading(true); // Set loading to true when auth state changes
//       setUser(currentUser);
//       if (currentUser) {
//         await fetchUserData(currentUser.uid);
//       } else {
//         setUserData(null);
//       }
//       setLoading(false); // Set loading to false after user data is fetched or cleared
//     });

//     return () => {
//       unsubscribe();
//     };
//   }, []);

//   return (
//     <userAuthContext.Provider
//       value={{
//         user,
//         userData,
//         loading, // Expose loading state
//         logIn,
//         signUp,
//         logOut,
//         resetPassword,
//         verifyPin,
//         updatePin,
//         updateBalance
//       }}
//     >
//       {children}
//     </userAuthContext.Provider>
//   );
// }

// export function useUserAuth() {
//   return useContext(userAuthContext);
// }